import Swiper from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';

/**
 * Initialize the slider controls
 *
 * @param swiperInstance {object} Swiper instance
 * @param $next {object} DOM Element of the button that sends us to the next slide
 * @param $prev {object} DOM Element of the button that sends us to the previous slide
 */
const initSliderControls = (swiperInstance, $next, $prev) => {
    if ($next !== null && $next !== undefined) {
        $next.addEventListener('click', event => {
            event.preventDefault();
            swiperInstance.slideNext();
        });
    }

    if ($prev !== null && $prev !== undefined) {
        $prev.addEventListener('click', event => {
            event.preventDefault();
            swiperInstance.slidePrev();
        });
    }
};

export default function initSliderContent() {
    //---------
    // Slider
    //---------

    // Do not initialize the slider in edit mode
    // TODO: mimic the slider via css in edit mode
    if (document.body.classList.contains('has-edit-mode-menu')) {
        return;
    }

    const $containers = document.querySelectorAll('.slider-content-container');
    $containers.forEach($container => {
        const $slider = $container.querySelector('.swiper');
        const $next = $container.querySelector('[data-action="slideRight"], [data-swiper-action="next"]');
        const $prev = $container.querySelector('[data-action="slideLeft"], [data-swiper-action="prev"]');
        const $autoplayDelay = $container.querySelector('.swiper-wrapper').dataset.autoplayDelay;

        // Initialize the slider
        const swiper = new Swiper($slider, {
            rewind: false,
            modules: [A11y, Autoplay],
            a11y: true,
            slidesPerView: 1,
            effect: 'creative',
            creativeEffect: {
                prev: {
                    translate: ['-100vw', 0, 0],
                },
                next: {
                    translate: ['100vw', 0, 0],
                },
            },
            autoplay: {
                delay: $autoplayDelay,
                disableOnInteraction: false,
            },
            on: {
                /**
                 * Initialize the slider controls, update the counter if it exists and check the amount of slides in
                 * case we have to hide the controls.
                 *
                 * @param swiper {object} Swiper instance
                 */

                afterInit: swiper => {
                    document.querySelectorAll('.slider-content').forEach($sliderContent => {
                        $sliderContent.style.opacity = 1;
                    });

                    initSliderControls(swiper, $next, $prev);

                    if (swiper.slides.length <= 1) {
                        if ($next !== null && $next !== undefined) {
                            $next.classList.add('is-hidden');
                        }

                        if ($prev !== null && $prev !== undefined) {
                            $prev.classList.add('is-hidden');
                        }
                    } else {
                        if ($next !== null && $next !== undefined) {
                            $next.classList.remove('is-hidden');
                        }

                        if ($prev !== null && $prev !== undefined) {
                            $prev.classList.remove('is-hidden');
                        }
                    }
                },
                slideChange: swiper => {
                    $prev.disabled = !!swiper.isBeginning;
                    $next.disabled = !!swiper.isEnd;
                },
            },
        });
    });
}
